import React from "react";
import { Hero, Section, CTA } from "../components/Page/Page.js";

export default function ManifestoScreen() {
  return (
    <>
      <Hero title="Our Manifesto" text="Solving the climate emergency starts today." />
      <Section>
        {[
          "Reduce first. Offsetting complements cutting emissions, it never replaces it.",
          "Only certified credits. If it can't be verified, we don't sell it.",
          "Reinvest. Proceeds go back into projects so impact compounds.",
          "Share the benefit. Communities should gain from the projects in their backyard.",
          "Be open. Methods, documents and retirements are public.",
        ].map((t, i) => (
          <p key={i} style={{ marginBottom: 24 }}><b>{i + 1}.</b> {t}</p>
        ))}
      </Section>
      <CTA />
    </>
  );
}
